<template>
  <div class="card edituser">
    <div class="header">
      <h4 class="title">
        {{ upd_ip.id ? translate('ip_profile.edit_address') : translate('ip_profile.create_address') }}
      </h4>
    </div>
    <div class="content">
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form_group">
              <label> {{ translate('ip_profile.server') }} </label>
              <tree-select
                v-model="upd_ip.server_id"
                :options="server_list"
                :multiple="false"
                :close-on-select="true"
                :clearable="false"
                :hide-selected="true"
                :max-height="165"
                :placeholder="translate('ip_profile.server')"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input
              v-model="upd_ip.name"
              type="text"
              label="Name"
              :placeholder="translate('ip_profile.name')"
            />
          </div>
          <div class="col-md-6">
            <fg-input
              v-model="upd_ip.short_name"
              type="text"
              :label="translate('ip_profile.name_short')"
              :placeholder="translate('ip_profile.name_short')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <fg-input
              v-model="upd_ip.ip"
              type="text"
              label="IP"
              placeholder="IP"
            />
          </div>
          <div class="col-md-2">
            <fg-input
              v-model="upd_ip.min"
              type="text"
              label="min"
              placeholder="min"
            />
          </div>
          <div class="col-md-2">
            <fg-input
              v-model="upd_ip.max"
              type="text"
              label="max"
              placeholder="max"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              v-model="upd_ip.ports"
              type="text"
              label="ports"
              placeholder="ports"
            />
          </div>
          <div class="col-md-2">
            <fg-input
              v-model="upd_ip.by_ports"
              type="text"
              label="by ports"
              placeholder="by ports"
            />
          </div>
        </div>
        <div class="row" v-if="upd_ip.time_life">
          <div class="col-md-12">
            <p>{{ translate("server.reservation_time_ip")}}: {{ upd_ip.time_life }}</p>
          </div>
        </div>
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="updateProfile"
          >
            {{ translate(upd_ip.id ? "btn.update" : "btn.add") }}
          </button>
          <button
            type="submit"
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
          >
            Cancel
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditIps',
  props: ["ips", "server_list"],
  data () {
    return {'upd_ip': {}}
  },
  beforeMount () {
    this.upd_ip = {...this.ips}
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    updateProfile () {
      this.$emit('update', this.upd_ip)
    }
  }
}
</script>
<style>

</style>
